import { render, staticRenderFns } from "./validCode.vue?vue&type=template&id=f18e9ace"
import script from "./validCode.vue?vue&type=script&lang=js"
export * from "./validCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports